import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { MATERIALS_MAP_VALUE_TO_LABEL } from './constants';

export const repairTagsManager = createTermsTagsManager({
  jsonQueryKey: 'repair',
  mapValueToLabel: MATERIALS_MAP_VALUE_TO_LABEL,
  id: 'repair',
});
